import { useState } from "react";

export const useIsVisibleModal = () => {
    const [isVisibleModal, setIsVisibleModal] = useState(false);
    return {isVisibleModal, setIsVisibleModal};

}